var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 16",
    style: {
      enableBackground: "new 0 0 22 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    d: "M20,0c1.1,0,2,0.9,2,2s-0.9,2-2,2c-0.3,0-0.6-0.1-0.9-0.2L3.9,13.5C4,13.7,4,13.8,4,14 c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2c0.4,0,0.7,0.1,1,0.3l15.1-9.6C18,2.4,18,2.2,18,2C18,0.9,18.9,0,20,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.d1a335217707eb8302b532aaa5a57ff4.svg";
export { ForwardRef as ReactComponent };